<div class="footer">
    <mat-icon
        class="dxc-logo"
        [svgIcon]="logo"
    >
    </mat-icon>
    <a
        class="privacy-policy"
        href={{consts.LINK_PRIVACY_POLICY}}
        target="_blank"
    >
        {{consts.LABEL_PRIVACY_POLICY}}
    </a>
    <a
        class="help-center"
        href={{consts.LINK_HELP}}
        target="_blank"
    >
        {{consts.LABEL_HELP_CENTER}}
    </a>
    <span
        class="copyright"
    >
        {{consts.LABEL_COPYRIGHT}}
    </span>
</div>
